module.exports = "build/wp/wp-content/themes/yom-choken/assets/css/style.css";